var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconView(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M.062 9.792C1.624 5.83 5.48 3.017 10 3.017c4.52 0 8.375 2.812 9.937 6.775a.75.75 0 010 .55c-1.562 3.963-5.418 6.775-9.937 6.775-4.52 0-8.376-2.812-9.938-6.775a.75.75 0 010-.55zm1.51.275c1.41 3.266 4.652 5.55 8.428 5.55 3.775 0 7.017-2.284 8.428-5.55-1.41-3.266-4.653-5.55-8.428-5.55-3.776 0-7.018 2.284-8.429 5.55z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M10 7.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM6.25 10a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z", clipRule: "evenodd" })));
}
export default IconView;
